var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"toast",domProps:{"textContent":_vm._s(_vm.message)}})])}
var staticRenderFns = []

export { render, staticRenderFns }